export default __webpack_public_path__ + "static/media/cardDealOutSFX.f1cf2162.mp3";